export const fallbackPartner = "asurion";
